module.exports = __webpack_public_path__ + "static/media/Signy Roberts Headshot.3bb341f2.jpeg";